<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ตั้งค่าค่าธรรมเนียมใบแจ้งหนี้</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ลาน: <span class="font-bold text-amber-600">{{ siteState.selectedSite()?.name || '-' }}</span>
      </p>
    </div>
    <div class="flex flex-wrap items-center gap-3">
      <button (click)="toggleDashboard()" class="px-4 py-3 bg-white/95 dark:bg-slate-900/95 rounded-2xl border border-slate-100/50 font-bold flex items-center gap-2">
        <span class="material-icons text-[18px]">bar_chart</span> แดชบอร์ด
      </button>
      <button (click)="onRefresh()" class="p-3 bg-white/95 dark:bg-slate-900/95 rounded-2xl border border-slate-100/50">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" (click)="navigateToCreate()"
        class="px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg flex items-center gap-2">
        <span class="material-icons">add_circle</span> เพิ่มรายการ
      </button>
    </div>
  </div>

  <div *ngIf="isDashboardOpen()" class="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
    <div *ngFor="let stat of dashboardStats()" class="bg-white/95 dark:bg-slate-900/95 rounded-2xl p-6 shadow-2xl border border-slate-100/50">
      <div class="flex items-center gap-3 mb-2">
        <span class="material-icons" [ngClass]="stat.color">{{ stat.icon }}</span>
        <h4 class="text-xs font-bold text-slate-400 uppercase">{{ stat.title }}</h4>
      </div>
      <div class="text-2xl font-black text-slate-800 dark:text-slate-100">{{ stat.value }}</div>
    </div>
  </div>

  <div class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden relative">
    <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

    <div class="p-6 border-b border-slate-100/50 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">payments</span> รายการค่าธรรมเนียม
      </h3>
      <div class="flex flex-wrap items-center gap-3">
        <label class="flex items-center gap-2 text-xs font-medium">
          <input type="checkbox" [ngModel]="showInactive()" (ngModelChange)="showInactive.set($event); onSearch()">
          แสดงรายการปิดใช้งาน
        </label>
        <div class="relative">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px]">search</span>
          <input type="text" placeholder="ค้นหา..." [ngModel]="searchText()" (ngModelChange)="searchText.set($event); onSearch()"
            class="pl-10 pr-4 py-2 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm w-64">
        </div>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[280px]">
      <table class="w-full text-left">
        <thead class="bg-slate-50 dark:bg-slate-800/50 text-xs uppercase text-slate-400">
          <tr>
            <th class="px-6 py-4">ชื่อรายการ</th>
            <th class="px-6 py-4">Fee Master</th>
            <th class="px-6 py-4">ประเภทรายรับ</th>
            <th class="px-6 py-4 text-right">จำนวนเงิน</th>
            <th class="px-6 py-4 text-center">VAT</th>
            <th class="px-6 py-4 text-center">ลำดับ</th>
            <th class="px-6 py-4 text-center">สถานะ</th>
            <th class="px-6 py-4 text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredAndPaginatedData()" class="border-t border-slate-100 dark:border-slate-800 hover:bg-slate-50/50 dark:hover:bg-slate-800/30">
            <td class="px-6 py-4 font-semibold text-slate-800 dark:text-slate-100">{{ item.name }}</td>
            <td class="px-6 py-4">{{ item.feeName || item.feeId }}</td>
            <td class="px-6 py-4">{{ item.feeTypeName || '-' }}</td>
            <td class="px-6 py-4 text-right">{{ item.fee | number:'1.2-2' }}</td>
            <td class="px-6 py-4 text-center">
              <span class="material-icons text-sm" [class.text-emerald-500]="item.vat" [class.text-slate-300]="!item.vat">
                {{ item.vat ? 'check_circle' : 'remove_circle_outline' }}
              </span>
            </td>
            <td class="px-6 py-4 text-center">{{ item.sortOrder }}</td>
            <td class="px-6 py-4 text-center">
              <span class="px-2 py-1 rounded-full text-xs font-bold"
                [ngClass]="item.status ? 'bg-emerald-50 text-emerald-600' : 'bg-slate-100 text-slate-500'">
                {{ item.status ? 'ใช้งาน' : 'ปิด' }}
              </span>
            </td>
            <td class="px-6 py-4">
              <div class="flex items-center justify-center gap-2">
                <button *ngIf="canUpdate" (click)="navigateToEdit(item)" class="p-2 rounded-lg hover:bg-amber-50 text-amber-600" title="แก้ไข">
                  <span class="material-icons text-[18px]">edit</span>
                </button>
                <button *ngIf="canDelete && item.status" (click)="deactivate(item)" class="p-2 rounded-lg hover:bg-rose-50 text-rose-500" title="ปิดใช้งาน">
                  <span class="material-icons text-[18px]">block</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && filteredAndPaginatedData().length === 0">
            <td colspan="8" class="px-6 py-16 text-center text-slate-400">ไม่พบข้อมูล</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="p-4 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3">
      <div class="text-xs text-slate-400">ทั้งหมด {{ totalItems() }} รายการ</div>
      <div class="flex items-center gap-2">
        <select [ngModel]="pageSize()" (ngModelChange)="pageSize.set(+$event); currentPage.set(1)" class="text-xs rounded-lg border-slate-200 dark:border-slate-700 bg-transparent px-2 py-1">
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} / หน้า</option>
        </select>
        <button *ngFor="let p of pagesArray" (click)="setPage(p)"
          class="w-8 h-8 rounded-lg text-xs font-bold"
          [ngClass]="p === currentPage() ? 'bg-amber-400 text-white' : 'bg-slate-100 dark:bg-slate-800 text-slate-500'">
          {{ p }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-invoice-fee *ngIf="isModalOpen()" [data]="selectedFee()" [siteId]="selectedSiteId"
  (close)="closeModal()" (saveSuccess)="loadFees()"></app-modal-invoice-fee>
